<div class="dialog-container">
    <h1 mat-dialog-title class="title">{{ data.titleKey | i18next  }}</h1>
    <img [src]="data.icon" mat-dialog-title class="title" alt="" />
    <div class="container">
        <p class="message">
            {{ data.descriptionKey | i18next  | replace : '{email}' : data.valueToReplace }}
        </p>
        <div style="display: flex">
            <span class="text-through">{{ data.currentState }}</span>
            <mat-icon>arrow_right_alt</mat-icon>
            <span class="bold">{{ data.newState }}</span>
        </div>

        <div class="action-wrapper">
            <a *ngIf="data.showCancel" (click)="closeDialog()">{{
                'aumico_admin_usermanagement_confirmation_modal_cancel_button' | i18next 
            }}</a>
            <a class="confirmation-action" (click)="applyActionAndClose()">
                {{ data.buttonTextKey | i18next  }}
            </a>
        </div>
    </div>
</div>
